<template>
    <div class="">
         <Header />
         <GSales/>
    </div>
</template>
<script>
import Header from "../components/Header.vue";
import GSales from '../components/gSalescomp.vue';
export default {
    components: {
        GSales,
        Header
  },
     data() {
      return {
        
      }
  }
}

</script>